const prefix = 'https://ui.goigi.biz/ago-sibillo-user-api/api/'
const prefixAsset = 'https://ui.goigi.biz/ago-sibillo-user-api/Assets/'
const prefixImg = 'https://ui.goigi.biz/ago-sibillo-user-api/uploads/'
// const prefix = 'http://localhost:8688/api/'
// const prefixAsset = 'http://localhost:8688/Assets/'
// const prefixImg = 'http://localhost:8688/uploads/'
export const Constants = {
  adminLogIn : prefix + 'admin/login',
  addSpecialities : prefix + 'admin/add-specialities',
  getSpecialities : prefix + 'admin/get-all-specialities',
  deleteSpecialities : prefix + 'admin/delete-speciality/',
  editSpecialities : prefix + 'admin/edit-specialities/',
  deleteUser : prefix + 'admin/delete-user/',
  getAllUsers : prefix + 'admin/fetchAllUsers',
  getAllAppointments : prefix + 'admin/fetch-all-appointments',
  deleteAppointments : prefix + 'admin/delete-appointment/',
  getDashboardMetrics : prefix + 'admin/fetchDashboardMetrics',
  createUser : prefix + 'auth/register',
  updateAdminCredentials : prefix + 'admin/update-admin-credentials/',
  getPatients : prefix + 'admin/fetch-all-patients',
  getDoctors : prefix + 'doctor/get-all-doctor-profiles',
  getAsset : prefixAsset,
  getImg : prefixImg
}
